import { rest } from "@auto/services";

const STANDARD_APPLICATION_TYPE = 1;
const searchAll = (entity) => rest.search(entity, {});
const number = (value) => Number(value || 0);
const isStandardRegistration = (row) => Number(row.applicationType) === STANDARD_APPLICATION_TYPE;

export const loadStatsSummary = async () => {
  const rows = await searchAll("stats-summary");
  return (rows || []).find(isStandardRegistration) || {};
};

export const loadStatsTimeline = async () => {
  const rows = await searchAll("stats-timeline");
  return (rows || [])
    .filter(isStandardRegistration)
    .sort((a, b) => String(a.date || "").localeCompare(String(b.date || "")));
};

export const loadStatsDemographics = async () => {
  const rows = await searchAll("stats-demographic");
  const filtered = (rows || []).filter(isStandardRegistration);

  return {
    sex: filtered.filter((row) => String(row.dimension || "").toUpperCase() === "SEX"),
    ageBands: filtered.filter((row) => String(row.dimension || "").toUpperCase() === "AGE"),
  };
};

let geographyPromise = null;
const loadGeographyReference = () => {
  if (!geographyPromise) {
    geographyPromise = searchAll("geography").catch((error) => {
      geographyPromise = null;
      throw error;
    });
  }
  return geographyPromise;
};

export const loadStatsGeography = async () => {
  const [geographies, stats] = await Promise.all([
    loadGeographyReference(),
    searchAll("stats-geography"),
  ]);

  const geographyById = new Map((geographies || []).map((row) => [Number(row.id), row]));

  return (stats || [])
    .filter(isStandardRegistration)
    .map((row) => ({
      ...row,
      geography: geographyById.get(Number(row.geographyId)) || null,
    }))
    .filter((row) => String(row.geography?.level || "").toUpperCase() === "DEPARTMENT")
    .map((row) => ({
      ...row,
      id: row.geographyId,
      gid: row.geography?.gid,
      code: row.geography?.code,
      name: row.geography?.name,
      applicationCount: number(row.applicationCount),
      registeredVoterCount: number(row.registeredVoterCount),
      distinctApplicantCount: number(row.distinctApplicantCount),
      activeOperatorCount: number(row.activeOperatorCount),
      activeVotingCenterCount: number(row.activeVotingCenterCount),
      capacity: number(row.capacity),
    }));
};

export const loadRegisteredVoterGeography = async (_filter, level = "DEPARTMENT") => {
  if (level !== "DEPARTMENT") {
    return [];
  }
  return loadStatsGeography();
};

